export const GET_GAITS_LIST = "GET_GAITS_LIST";
export const GAITS_PROCESSING = "GAITS_PROCESSING";
export const STOP_GAITS_PROCESSING = "STOP_GAITS_PROCESSING";
export const GET_GAITS_ADMENTOS = "GET_GAITS_ADMENTOS";
